module.exports = __webpack_public_path__ + "img/ENK-m.09349766.png";